import { render, staticRenderFns } from "./Addlink.vue?vue&type=template&id=21874e84&scoped=true"
import script from "./Addlink.vue?vue&type=script&lang=js"
export * from "./Addlink.vue?vue&type=script&lang=js"
import style0 from "./Addlink.vue?vue&type=style&index=0&id=21874e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21874e84",
  null
  
)

export default component.exports